import { memoryExpiresOnOptions, memorySavesOnOptions, memoryScopeOptions, embeddedMemoryScopeOptions } from '@shared/schema/aiSchemas/passive/workflowSchemas/memorySchema.js';
import Input from '@/components/Input.jsx';
import Panel from '@/components/panel/Panel.jsx';
import { BiSave, BiText, MdOutlinePublic, RxLapTimer } from '@/components/react-icons/main';
import ArgumentLabel from '../ArgumentLabel.jsx';
import ArgumentWrapper from '../ArgumentWrapper.jsx';
import useMemoryKeyInputValidation from '@/hooks/useMemoryKeyInputValidation.js';
import workflowScreenSelectors from '@/screens/workflows/redux/selectors/workflowScreenSelectors.js';
import { useSelector } from 'react-redux';

const MemorySliderItem = ({ memory, handleDelete, handleChange, getLabel, disabled = false }) => {
  const { memoryKey, memoryKeyDescription, invalidKey } = useMemoryKeyInputValidation({ key: memory.key, scope: memory.scope });
  const isEmbedded = useSelector(workflowScreenSelectors.activeWorkflowIsEmbedded);
  const scopeOptions = isEmbedded ? embeddedMemoryScopeOptions : memoryScopeOptions;

  return (
    <Panel.Section title="Memory" onDelete={() => handleDelete(memory.id)} collapsable={false}>
      <ArgumentWrapper>
        <ArgumentLabel label="Key" icon={BiText} />
        <Input disabled={disabled} value={memoryKey} onChange={(e) => handleChange(memory.id, 'key', e.target.value)} placeholder="Enter memory key..." description={memoryKeyDescription} className={invalidKey ? 'error' : ''} />
      </ArgumentWrapper>
      <Panel.LexicalInput key={!!memory.key} label="Value" icon={BiText} value={memory.value} onChange={(value) => handleChange(memory.id, 'value', value)} placeholder="Set a Value" disabled={!memory.key} allowSelfOutput={true} />
      <ArgumentWrapper>
        <ArgumentLabel label="Scope" icon={MdOutlinePublic} />
        <Panel.ToggleButton options={scopeOptions} value={memory.scope || 'workflow'} onChange={(value) => handleChange(memory.id, 'scope', value)} disabled={disabled || !memory.key} fullWidth size="sm" />
      </ArgumentWrapper>
      <ArgumentWrapper>
        <ArgumentLabel label="Saves On" icon={BiSave} />
        <Panel.ToggleButton options={memorySavesOnOptions} value={memory.savesOn || 'success'} onChange={(value) => handleChange(memory.id, 'savesOn', value)} disabled={disabled || !memory.key} fullWidth size="sm" />
      </ArgumentWrapper>
      <Panel.Select label="Expires After" icon={RxLapTimer} value={getLabel(memory.expiresOn || 'never', memoryExpiresOnOptions)} onChange={({ value }) => handleChange(memory.id, 'expiresOn', value)} placeholder="Select when the value will expire" options={memoryExpiresOnOptions} disabled={disabled || !memory.key} />
    </Panel.Section>
  );
};

export default MemorySliderItem;
